export const applicationRouteNames = {
  form: 'form',
  successAdhesion: 'form/succes',
  reporting: 'reporting',
  backOffice: 'back-office',
  administration: 'administration',
  users: 'users',
  lokalise: 'lokalise',
};
